import { createSelector } from '@reduxjs/toolkit';

const selectLixaniPaintState = (state) => state.lixaniPaint;

export const selectIsLixaniPaintDialogOpen = createSelector(
  [selectLixaniPaintState],
  (state) => state.isLixaniPaintDialogOpen
);

export const selectLixaniPaintCurrentImageUrl = createSelector(
  [selectLixaniPaintState],
  (state) => state.currentImageUrl
);

export const selectLixaniPaintImageMetadata = createSelector(
  [selectLixaniPaintState],
  (state) => state.imageMetadata
);
